import authServices from '../services/auth'
import global from '../config/global'
import { getRouterByLocation } from '../utils/common'

export async function handleResponseErrorMessage(err) {
  const currentPage = getRouterByLocation(window.location)
  if (err.response === undefined) {
    return err
  }
  if (err.response.status === 401) {
    authServices.logout();
    return
  }
  if (err.response.status === 400) {
    if (err.response?.data?.code == '0010') {
      global.navigate('SETTING_DB')
    }
  }
  if ([403, 404, 500, 502].includes(err.response.status)) {
    const isLocked = await global.jsCore?.vaultTimeoutService.isLocked()
    if (!isLocked) {
      global.navigate('ADMIN_ERROR', currentPage.params || {}, { code: err.response.status })
    }
  }
  return err
}
